import { saveRequestAccessHandoff } from './RequestAccessNavigationHandoff';
import {
  BatchExecutionResult,
  EditOrRenewActionContext,
  LifecycleGridItem,
  RequestAccessHandoffPayload,
} from './MyAccessRequests.types';
import { evaluateEditEligibility, isEditRenewSupportedTenant } from './MyAccessRequests.lifecycleEligibility';

const buildEditHandoff = (tenantName: string, item: LifecycleGridItem): RequestAccessHandoffPayload => ({
  version: 1,
  tenantName,
  action: 'edit',
  requestedAtUtc: new Date().toISOString(),
  item,
});

export async function executeEditSelected(context: EditOrRenewActionContext): Promise<BatchExecutionResult> {
  const { item, tenantName, updateRowExecutionState } = context;

  if (!isEditRenewSupportedTenant(tenantName)) {
    updateRowExecutionState(item.requestId, 'failed', 'Edit from Request History is not supported for this tenant yet');
    return { total: 1, successCount: 0, failedCount: 1 };
  }

  const eligibility = evaluateEditEligibility(item, {
    tenantName,
    allItems: context.allItems,
    accessExpiryReminderWindowDays: context.accessExpiryReminderWindowDays,
    approvedAccesses: context.approvedAccesses,
  });

  if (!eligibility.isEligible) {
    updateRowExecutionState(item.requestId, 'failed', eligibility.reason || 'Item is not eligible for edit');
    return { total: 1, successCount: 0, failedCount: 1 };
  }

  saveRequestAccessHandoff(buildEditHandoff(tenantName, item));
  updateRowExecutionState(item.requestId, 'success', 'Redirecting to Access Request for edit');
  context.navigateToRequestAccess();

  return { total: 1, successCount: 1, failedCount: 0 };
}
